<template>
  <div id="admin">
    <menu-admin/>
    <div class="jumbotron jumbotron-fluid">
      <div class="container">
        <div class="row">
          <div class="col-12">
            <h1 class="title text-center">
              <i class="fa fa-signature"></i>
              <span>#{{signature.id}} {{signature.publication.name}} </span>
            </h1>
          </div>
        </div>
      </div>
    </div>
    <section class="int-form">
      <div class="container">
        <div class="row">
          <div class="col-12">
            <form v-if="signature.publication.name != ''">
              <div class="card-details">
                <h3 class="title">Detalhes da publicação</h3>
                <div class="row">
                  <div class="form-group col-sm-6">
                    <label for="date">Vencimento</label>
                    <input :disabled="!signature.publication.is_signature" id="date" type="text" v-mask="'##/##/####'" class="form-control" v-model="date" placeholder="" aria-label="" aria-describedby="basic-addon1">
                    <span class="errorForm"></span>
                  </div>
                  <div class="form-group col-sm-6">
                    <label>Status</label>
                    <select :disabled="signature.status.id == 3 || signature.status.id == 2" id="status" class="form-control" v-model="signature.status.id">
                      <option value="1">Download liberado</option>
                      <option value="5">Ativa</option>
                      <option value="2">Aguardando envio</option>
                      <option value="3">Enviado</option>
                      <option value="4">Vencida</option>
                    </select>
                    <span class="errorForm"></span>
                  </div>
                  <div class="form-group col-sm-6" v-show="(signature.status.id===3 || signature.status.id==='3') && signature.track_code != ''">
                    <label>Código de rastreio</label>
                    {{signature.track_code}}
                    <span class="errorForm"></span>
                  </div>
                  <div class="form-group col-sm-6" v-show="(signature.status.id===3 || signature.status.id==='3') && signature.expedition_date != null">
                    <label>Data de expedição</label>
                    {{signature.expedition_date}}
                    <span class="errorForm"></span>
                  </div>
                </div>
                <hr/>
                <div class="row">
                  <div class="form-group col-sm-4">
                    <label>Publicação</label>
                    <br/>{{signature.publication.name}}
                  </div>
                  <div class="form-group col-sm-4">
                    <label>Cliente</label>
                    <br/><span v-if="signature.profile.person_or_company">{{ signature.profile.company_name }}</span><span v-else>{{ signature.profile.name }}</span>
                  </div>
                  <div class="form-group col-sm-4">
                    <label>E-mail</label>
                    <br/>{{signature.profile.user.email}}
                  </div>
                  <div class="form-group col-sm-4">
                    <label>Telefone</label>
                    <br/>{{signature.profile.phone}}
                  </div>
                  <div class="form-group col-sm-4">
                    <label>Pedido</label>
                    <br/>#{{signature.order.id}}
                  </div>
                  <div class="form-group col-sm-4">
                    <label>Expedição</label>
                    <br/>
                    <span v-if="signature.order.expedition">
                      <a :href="'/admin/expedition/' + signature.order.expedition.id">#{{ signature.order.expedition.id }}</a>
                        ({{ signature.order.expedition.status.name }})</span>
                    <span v-else><a :href="'/admin/expedition/0/'+ signature.id">Adicionar</a></span>
                  </div>
                </div>
                <hr/>

                <span v-show="signature.publication.has_airplane_info">
                <div class="row">
                  <div class="form-group col-sm-4">
                    <label>Prefixo da aeronave</label>
                    <br/>{{signature.airplane_prefix}}
                  </div>
                  <div class="form-group col-sm-4">
                    <label>Número de série</label>
                    <br/>{{signature.airplane_serial_number}}
                  </div>
                  <div class="form-group col-sm-4">
                    <label>Tipo de combustível</label>
                    <br/>{{signature.fuel_type | nameFuelType}}
                  </div>
                </div>
                <hr/>
                  </span>

                <h3 class="title" style="border-bottom: 0">Endereço de entrega</h3>
                <div class="row">
                  <div class="form-group col-sm-4">
                    <label>País</label>
                    <br/>{{signature.profile.shipping_address.country}}
                  </div>
                  <div class="form-group col-sm-4">
                    <label>Cidade</label>
                    <br/>{{signature.profile.shipping_address.city}}
                  </div>
                  <div class="form-group col-sm-4">
                    <label>Estado</label>
                    <br/>{{signature.profile.shipping_address.state}}
                  </div>
                  <div class="form-group col-sm-4">
                    <label>Endereço</label>
                    <br/>{{signature.profile.shipping_address.street}}
                  </div>
                  <div class="form-group col-sm-4">
                    <label>Número</label>
                    <br/>{{signature.profile.shipping_address.number}}
                  </div>
                  <div class="form-group col-sm-4">
                    <label>Complemento</label>
                    <br/>{{signature.profile.shipping_address.complement}}
                  </div>
                  <div class="form-group col-sm-4">
                    <label>Bairro</label>
                    <br/>{{signature.profile.shipping_address.province}}
                  </div>
                  <div class="form-group col-sm-4">
                    <label>CEP</label>
                    <br/>{{signature.profile.shipping_address.zip_code}}
                  </div>
                </div>

                <hr/>
                <h3 class="title" style="border-bottom: 0">Observações</h3>
                <div class="row">
                  <div class="form-group col-sm-12">
                    <textarea rows="10" class="form-control" v-model="signature.notes"></textarea>
                  </div>
                </div>

              </div>
              <hr/>
              <div class="card-details" style="padding-top: 0">
                <div class="row">
                  <div class="form-group col-sm-12">
                    <div id="sucessUpdate" class="alert alert-success text-center" role="alert" style="display: none;">As informações foram salvas com sucesso</div>
                    <div id="errorFound" class="alert alert-danger text-center" role="alert" style="display: none">Um erro foi encontrado. Verifique os campos do formulário</div>
                    <button type="button" class="btn btn-secondary" onclick="window.history.back()">Voltar</button>
                    <button type="button" class="btn btn-primary pull-right" @click="savesignature()">Salvar</button>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </section>
    <footer-admin/>
  </div>
</template>

<script>
  import signature from "../../api/signature"
  import menuAdmin from "../admin/common/menu-admin"
  import footerAdmin from "../admin/common/footer-admin"
  import { mapState } from 'vuex'
  import mixins from "../../helpers/mixins"
  import {VMoney} from 'v-money'
  // import Datepicker from 'vuejs-datepicker';
  import {ptBR} from 'vuejs-datepicker/dist/locale'
  import moment from 'moment'

  export default {
    name: "AdminSignaturesView",
    mixins: [mixins],
    data () {
      return {
        signature: { id: null, publication: { name: '' } },
        date: '',
        ptBR: ptBR
      }
    },
    components: { menuAdmin, footerAdmin },
    computed: {
      ...mapState(['logged'])
    },
    directives: { money: VMoney },
    methods: {
      getsignature(id){
          signature.get(id).then((response)  =>  {
            this.signature = response.data
            if(this.signature.expedition_date)
              this.signature.expedition_date = moment(this.signature.expedition_date).format('YYYY/MM/DD');
            this.date = this.formatDate(this.signature.due, 'pt-br')
          })
      },
      customFormatter(date) {
        return moment(date).format('MM/DD/YYYY');
      },
      savesignature(){
          $("#sucessUpdate").hide()
          let expedition_date = null
          if(this.signature.expedition_date !== '' && this.signature.expedition_date){
            expedition_date = moment(this.signature.expedition_date).format('YYYY-MM-DD')
          }
          let data =             {
              "status": parseInt(this.signature.status.id),
              "publication": this.signature.publication.id,
              "order": this.signature.order.id,
              "profile": this.signature.profile.id,
              "track_code": this.signature.track_code,
              "expedition_date":  expedition_date,
              "notes": this.signature.notes
          }
          data.due = this.formatDate(this.date)

          signature.update(data, this.signature.id).then((response) => {
              if(response.status === 200){
                $("#sucessUpdate").show()
              } else {
                alert('ATENÇÃO: Não foi possivel atualizar a publicação!');
              }
            }).catch(errors => { this.formErrors(errors) })
      }
    },
    mounted(){
      if(this.$route.params.id !== undefined && this.$route.params.id > 0)
        this.getsignature(this.$route.params.id)
    }
  }
</script>
<style scoped>
  .jumbotron-fluid{
    padding-top: 100px;
    padding-bottom: 20px;
    margin-bottom: 10px;
  }
</style>
